import { Create, Edit, List, SimpleForm, BooleanInput, TextInput, required, Datagrid, TextField, EditButton } from 'react-admin';
import { default as icon } from '@mui/icons-material/Science';

const list = () =>
    <List>
		<Datagrid>
			<TextField source="name" />
			<TextField source="description" />
			<EditButton />
		</Datagrid>
    </List>;

const FormFields = (
	<SimpleForm>
		<TextInput source="name" validate={required()} />
		<TextInput source="description" />
		<TextInput source="body" label="Methodology" multiline />
		<BooleanInput source="active" defaultValue={true} />
	</SimpleForm>
);

const edit = () => <Edit>{FormFields}</Edit>;
const create = () => <Create>{FormFields}</Create>;


export const Methodology = { list, edit, create, icon };

export default Methodology;